import localeData from 'dayjs/plugin/localeData'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isToday from 'dayjs/plugin/isToday'
import isYesterday from 'dayjs/plugin/isYesterday'
import isBetween from 'dayjs/plugin/isBetween'
import duration from 'dayjs/plugin/duration'
import minMax from 'dayjs/plugin/minMax'
import timeZone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import dayUtc from 'dayjs/plugin/utc'
import dayjs from 'dayjs'
import calendar from 'dayjs/plugin/calendar'

dayjs.extend(customParseFormat)
dayjs.extend(isBetween)
dayjs.extend(isToday)
dayjs.extend(duration)
dayjs.extend(minMax)
dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)
dayjs.extend(timeZone)
dayjs.extend(localeData)
dayjs.extend(dayUtc)
dayjs.extend(calendar)
dayjs.extend(isYesterday)

export type Dayjs = dayjs.Dayjs

export type { ConfigType, ManipulateType } from 'dayjs'

export default dayjs
